module.exports = __webpack_public_path__ + "static/media/gc-recepcionist.eed60c01.png";